var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyDeployment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46967 10.5303C6.76256 10.8232 7.23744 10.8232 7.53033 10.5303L10 8.06066L12.4697 10.5303C12.7626 10.8232 13.2374 10.8232 13.5303 10.5303C13.8232 10.2374 13.8232 9.76256 13.5303 9.46967L10 5.93934L6.46967 9.46967C6.17678 9.76256 6.17678 10.2374 6.46967 10.5303Z",
    fill: "#A3B0C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.25C10.4142 6.25 10.75 6.58579 10.75 7V19C10.75 19.4142 10.4142 19.75 10 19.75C9.58579 19.75 9.25 19.4142 9.25 19V7C9.25 6.58579 9.58579 6.25 10 6.25Z",
    fill: "#A3B0C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.5C0 9.35802 1.22445 7.50204 3.01159 6.5938C3.22197 2.91685 6.27035 0 10 0C13.7296 0 16.778 2.91685 16.9884 6.5938C18.7755 7.50204 20 9.35802 20 11.5C20 14.369 17.8032 16.725 15 16.9776V17H13V15.5H14.6837L14.8654 15.4836C16.9025 15.3001 18.5 13.5857 18.5 11.5C18.5 9.94436 17.6123 8.59344 16.3088 7.93103L15.5401 7.54036L15.4909 6.67949C15.3256 3.79179 12.9299 1.5 10 1.5C7.07008 1.5 4.67436 3.79179 4.50914 6.67949L4.45988 7.54036L3.69117 7.93103C2.38774 8.59344 1.5 9.94436 1.5 11.5C1.5 13.5857 3.09749 15.3001 5.13463 15.4836L5.31625 15.5H7V17H5V16.9776C2.19675 16.725 0 14.369 0 11.5Z",
    fill: "#A3B0C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDeployment);
export default __webpack_public_path__ + "static/media/empty-deployment.0eee9937473ec514e1de50532e3f33c3.svg";
export { ForwardRef as ReactComponent };